export default "__VITE_ASSET__CdQ1ba57__"